<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I1KgEv/tc-custom/9781468309911.jpg?1734322225558" alt="This image is the cover for the book Illusionists"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Illusionists
      </h1>
      <p class="bookDescription body article font2">
        <b>“Beneath this buoyant tale of down-market entertainers in Victorian London rumbles a heavyweight novel . . . Intricate and thrilling” (<i>The New York Times</i>).</b><br/>  <br/> A young, beautiful woman of limited means, Eliza is modern before her time. Not for her the stifling—if respectable—conventionality of marriage, children, domestic drudgery. She longs for more. Through her work as an artist’s model, she meets the magnetic and irascible Devil—a born showman whose dream is to run his own theater company. Devil’s right-hand man is the improbably named Carlo Boldoni, an ill-tempered dwarf with an enormous talent for all things magic and illusion. Carlo and Devil clash at every opportunity and it constantly falls upon Eliza to broker an uneasy peace between them. And then there is Jasper Button. Mild-mannered and a family man at heart, it is his gift as an artist that makes him the unlikely final member of the motley crew.<br/>  <br/> Thrown together by a twist of fate, their lives are inextricably linked: The fortune of one depends on the fortune of the other. And as Eliza gets sucked into the seductive and dangerous world her strange companions inhabit, she risks not only her heart, but also her life, which is soon thrown into peril.<br/>  <br/> “Love, seduction, magic and illusion collide . . . A spellbinding journey through an extremely shadowy world.” —<i>Daily Express</i><br/>  <br/> “A brilliant Gothic mix of glitter and grime.” —<i>Daily Mail</i><br/>  <br/> “Thomas’s sprawling follow-up to <i>The Kashmir Shawl</i> . . . A story of a theater company, a thriller, and, most successfully, a portrait of a woman trying to create an equal partnership with a man.” —<i>Publishers Weekly</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rosie Thomas
      </h2>
      
      <p class="authorDescription body article">Rosie Thomas is the author of numerous critically acclaimed, bestselling novels, and has twice won the Romantic Novel of the Year Award. Born in a small village in northern Wales, Thomas discovered a love of traveling and mountaineering when her children were grown. In the years since, she has climbed in the Alps and the Himalayas, competed in the Peking to Paris car rally, and trekked in the footsteps of Shackleton on South Georgia Island.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3bed64b3